import React from 'react';

export function InputItem(props) {
  
  return (
    <label className={`form__label form__label_type_${props.types}`} htmlFor={props.name}> {props.nameru}
    <input 
      type={props.type}
      autoComplete="off" 
      value={props.value || ''} 
      step='any'
      onChange={props.onChange} 
      placeholder={props.placeholder}
      className = {`form__input form__input_type_${props.name}`} 
      name={props.name} 
      id={props.id} 
    />
    {props.nameError && <span className="email-error form__input_error">{props.nameError}</span>}
     </label>
  )        
}
  